import { z } from "zod";

/**
 * Shared DTO Admin Anonymize / Delete-account (US-AE3.F4-0012 · @UC9023) — một nguồn sự thật
 * api (S01 — endpoint) ↔ admin web (S04 — dialog xác nhận + lý do), tránh drift shape (DRY).
 *
 * BẢO MẬT (invariants):
 * - Request `.strict()` — CHỈ nhận `reason`, chặn field lạ (chống lẫn PII/secret vào body — C5).
 * - Response chỉ định danh + status='anonymized' — KHÔNG PII/secret/tiền (C2/C3).
 * - Lý do (reason) lưu vào audit_log ở backend (KHÔNG cột riêng — nhất quán suspend F3).
 * - Error code CANONICAL (khớp DELETE /v1/me — cùng thao tác soft-delete + anonymize; single source):
 *   · FINANCIAL_POSITION_NONZERO — MỌI ràng buộc tài chính chặn ẩn danh: owner-của-nhóm-có-quỹ
 *     đang-hoạt-động, member_due chưa đóng, debt_entry mở (nộp hộ / dư), loan chưa tất toán.
 */

/** Độ dài tối đa lý do ẩn danh — chặn input phình; đủ ghi chú nghiệp vụ (đối xứng suspend F3). */
export const ANONYMIZE_REASON_MAX_LENGTH = 500;

/** Body POST /admin/users/:id/anonymize — reason bắt buộc (1..500). `.strict()` chặn field lạ. */
export const anonymizeUserRequestSchema = z
  .object({
    reason: z.string().min(1).max(ANONYMIZE_REASON_MAX_LENGTH),
  })
  .strict();

export type AnonymizeUserRequest = z.infer<typeof anonymizeUserRequestSchema>;

/** Response anonymize: định danh + status='anonymized' (literal). `.strict()` chặn field dư. */
export const anonymizeUserResponseSchema = z
  .object({
    userId: z.string(),
    status: z.literal("anonymized"),
  })
  .strict();

export type AnonymizeUserResponse = z.infer<typeof anonymizeUserResponseSchema>;

/**
 * Code 409 CHẶN ẩn danh khi user còn BẤT KỲ ràng buộc tài chính nào (canonical, khớp DELETE /v1/me):
 * owner-của-nhóm-có-quỹ-đang-hoạt-động, member_due chưa đóng, debt_entry mở, loan chưa tất toán.
 * Khớp domain errors.ts FINANCIAL_POSITION_NONZERO (single source).
 */
export const ANONYMIZE_FINANCIAL_POSITION_NONZERO_CODE = "FINANCIAL_POSITION_NONZERO" as const;
